import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRIVACY_POLICY_API } from 'api/show-authenticated-privacy-policy';
import { acceptUserTerms } from 'api/accept-user-terms';

export const useAcceptUserTerms = () => {
  const queryClient = useQueryClient();

  const acceptTerms = useMutation({
    mutationFn: (version: string) => acceptUserTerms(version),
  });

  const ERROR_TEXT: string = 'error accepting terms';

  return async (version: string) => {
    try {
      const response = await acceptTerms.mutateAsync(version);

      await queryClient.invalidateQueries({ queryKey: [PRIVACY_POLICY_API] });
      return { success: Boolean(response.date_accepted) };
    } catch (error) {
      throw new Error(ERROR_TEXT);
    }
  };
};
